// MSE 播放器工厂：按平台返回 flv.js 或 mpegts.js。
//
// iOS 17.1+ 引入 ManagedMediaSource（MSE 的省电版），window.MediaSource 仍 undefined。
// flv.js 不识别 ManagedMediaSource → iOS 上 isSupported()=false。
// mpegts.js 是 flv.js 同维护者的现代 fork，原生支持 ManagedMediaSource → iOS 17.1+ 可用。
//
// 策略：
// - iOS 17.1+（无 MediaSource、有 ManagedMediaSource）→ mpegts.js
// - 其他（有 MediaSource）→ flv.js（保持现状不变，零回归风险）
//
// API 1:1 兼容（mpegts.js 是 flv.js fork）：isSupported / createPlayer / Events 全一致。
// 调用方只 import 这里，不直接 import flv.js / mpegts.js。

import flvjs from 'flv.js';
import mpegts from 'mpegts.js';

export interface MsePlayerInstance {
	attachMediaElement(el: HTMLVideoElement): void;
	detachMediaElement(): void;
	load(): void;
	play(): Promise<void> | void;
	pause(): void;
	unload(): void;
	destroy(): void;
	on(event: string, cb: (...args: unknown[]) => void): void;
}

interface MsePlayerNs {
	isSupported(): boolean;
	createPlayer(
		ds: { type: string; url: string; isLive?: boolean; cors?: boolean },
		config?: { enableWorker?: boolean; enableStashBuffer?: boolean; stashInitialSize?: number },
	): MsePlayerInstance;
	Events: { MEDIA_INFO: string; ERROR: string; [k: string]: string };
}

const w = window as unknown as { MediaSource?: typeof MediaSource; ManagedMediaSource?: typeof MediaSource };
const useIosMse = typeof window !== 'undefined' && !w.MediaSource && !!w.ManagedMediaSource;

export const msePlayer: MsePlayerNs = (useIosMse ? mpegts : flvjs) as unknown as MsePlayerNs;
export const isUsingMpegts = useIosMse;

if (typeof window !== 'undefined') {
	console.log(`[ulucu] MSE player: ${useIosMse ? 'mpegts.js (iOS 17.1+)' : 'flv.js'} | supported=${msePlayer.isSupported()}`);
}
